// extracted by css-extract-rspack-plugin
export default {"root":"n96Rn"};